module.exports = __webpack_public_path__ + "img/count-back.83948f0f.png";